import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"minus-small, remove, delete"} maskId="square-filled-radius-0-stroke-1-IconMinusSmall"><path fillRule="evenodd" clipRule="evenodd" d="M6 11.5H18V12.5H6V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMinusSmall;
